import InfiniteScroll from 'react-infinite-scroll-component';
import type { ReactNode } from 'react';
import { classNames } from '@library/utils';

export interface InfiniteScrollProps {
  dataLength: number;
  hasMore: boolean;
  loader: ReactNode;
  next: () => void;
  scrollableTarget?: string;
}

export interface TableBodyInfiniteScrollProps {
  bodyHeight: string;
  bodyMaxHeight: string; // Use tailwind max-h-* class
  children: ReactNode;
  className?: string;
  infiniteScrollProps: InfiniteScrollProps;
  scrollId: string;
}

export const TableBodyInfiniteScroll = ({
  bodyHeight,
  bodyMaxHeight,
  children,
  className = 'min-w-[1020px]',
  infiniteScrollProps,
  scrollId
}: TableBodyInfiniteScrollProps) => {
  return (
    <div
      className={classNames(
        'no-scrollbar flex flex-col overflow-y-auto',
        bodyMaxHeight,
        className
      )}
      id={scrollId}
      style={{ height: bodyHeight }}
    >
      <InfiniteScroll {...infiniteScrollProps} scrollableTarget={scrollId}>
        {children}
      </InfiniteScroll>
    </div>
  );
};
